module.exports = __webpack_public_path__ + "img/pre-analise-credito.c17a0e14.svg";